import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';

import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';
import styles from './ErknmActsHistory.module.scss';

interface IHistoryProps {
  act: IKnmErknmFormAct;
  isPaperless: boolean;
}

export const ErknmActHistory = ({ act, isPaperless }: IHistoryProps) => {
  const { created, createdBy, updated, updatedBy, canceled: isCanceled, fileInvalidate } = act;

  if (isPaperless && !created) {
    return <div className={styles.ActStatus}>Черновик</div>;
  }

  if (isPaperless && fileInvalidate) {
    return <div className={styles.ActStatusCanceled}>Отменено</div>;
  }

  const createdFormatedDate = formatDate({
    date: created || '',
    dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
    parseFormat: DATE_FORMAT_ISO_FNS,
  });

  const updatedFormatedDate = formatDate({
    date: updated || '',
    dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
    parseFormat: DATE_FORMAT_ISO_FNS,
  });

  if (isCanceled) {
    return (
      <div className={styles.ActCanceled} data-color="red">
        Отменено
      </div>
    );
  }

  return (
    <Tooltip
      placement="left"
      type="history"
      content={
        updated ? (
          <div className="shared-tooltip-history-content">
            Создан {createdBy?.fullName} ({createdBy?.username}) {createdFormatedDate}
            <br />
            Обновлен {updatedBy?.fullName} ({updatedBy?.username}) {updatedFormatedDate}
          </div>
        ) : (
          <div className="shared-tooltip-history-content">
            Создан {createdBy?.fullName} ({createdBy?.username}) {createdFormatedDate}
          </div>
        )
      }
    >
      <span className="shared-tooltip-history-icon" />
    </Tooltip>
  );
};
